import {load} from '@shopify/theme-sections';
import '../sections/product';
import '../sections/product-recommendations';
import '../sections/product-recently-viewed';
import '../sections/bazaar-voice-reviews';
import '../sections/before-after';
import '../sections/experts-say';
import '../sections/quotes-carousel';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
